// Where a signed-in person's Pro access comes from, for labelling it. The header pill and the
// profile page used to assume "Pro" always means a personal Day Pass or Monthly plan, so:
//  - a team or organization member who once bought a Day Pass saw "Day Pass · Expired" while fully covered;
//  - a covered person with no personal plan was told "10 uses per day" on their profile.
// A personal plan that is still running wins; otherwise the organization, then the team.

export interface AccessStatus {
  isPro: boolean;
  proAccessUntil: string | Date | null;
  activePlan: string | null;
  organization?: { orgName: string; until: string | Date } | null;
  team?: { seats?: number; currentPeriodEnd: string | Date | null } | null;
}

export interface AccessSource {
  kind: "personal" | "organization" | "team";
  /** Short label for the header pill. */
  shortLabel: string;
  /** Fuller label for the profile page. */
  label: string;
  until: Date | null;
}

const asDate = (v: string | Date | null | undefined): Date | null => (v ? new Date(v) : null);

export function accessSource(status: AccessStatus | null | undefined, now: number = Date.now()): AccessSource | null {
  if (!status?.isPro) return null;
  const personalUntil = asDate(status.proAccessUntil);
  if (personalUntil && personalUntil.getTime() > now) {
    const label = status.activePlan === "monthly" ? "Monthly Pro" : "Day Pass";
    return { kind: "personal", shortLabel: label, label, until: personalUntil };
  }
  if (status.organization) {
    return { kind: "organization", shortLabel: "Organization", label: `Organization plan: ${status.organization.orgName}`, until: asDate(status.organization.until) };
  }
  if (status.team) {
    return { kind: "team", shortLabel: "Team", label: "Team plan", until: asDate(status.team.currentPeriodEnd) };
  }
  return null;
}
